import React, { ComponentProps } from 'react';

import { Chip } from '~/components/blocks';
import { ReceptionStatus } from '~/components/partials/ReceptionStatus';
import { AppointmentStatus, ReceptionUberDeliveryFragment } from '~/graphql/generated/graphql';

type Props = {
  size?: ComponentProps<typeof Chip>['size'];
  uberDelivery?: ReceptionUberDeliveryFragment | null | undefined;
  status: AppointmentStatus;
  isSameDayDelivery?: boolean;
};

export const UberDeliveryAppointmentStatusLabel = (props: Props) => {
  const { status, uberDelivery, isSameDayDelivery } = props;

  const uberDeliveryStatus = uberDelivery?.status;

  if (!isSameDayDelivery) {
    return null;
  }

  if (!uberDelivery && status === 'waiting_for_charge') {
    return (
      <ReceptionStatus
        label="集荷待ち"
        chipColor="cyan"
        labelColor="white"
        detailedStatus={{ label: '未依頼', color: 'pink', iconName: 'uber' }}
      />
    );
  }

  if (uberDeliveryStatus === 'uber_support_canceled') {
    return (
      <ReceptionStatus
        label="配達待ち"
        chipColor="grey"
        labelColor="white"
        detailedStatus={{ label: 'キャンセル', color: 'pink', iconName: 'uber' }}
      />
    );
  }

  if (uberDeliveryStatus === 'before_dropoff_canceled' && status === 'waiting_for_charge') {
    return (
      <ReceptionStatus
        label="集荷待ち"
        chipColor="cyan"
        labelColor="white"
        detailedStatus={{ label: '未依頼', color: 'pink', iconName: 'uber' }}
      />
    );
  }

  if (uberDeliveryStatus === 'unfulfilled' && status === 'waiting_for_charge') {
    return (
      <ReceptionStatus
        label="集荷待ち"
        chipColor="cyan"
        labelColor="white"
        detailedStatus={{ label: '未依頼', color: 'pink', iconName: 'uber' }}
      />
    );
  }

  if (uberDeliveryStatus === 'dropoff' && status === 'charged') {
    return <ReceptionStatus label="配達待ち" chipColor="grey" labelColor="white" />;
  }

  // 返送が終わるまでは、予約が完了していても配達の状況を見せる
  if (
    uberDeliveryStatus === 'canceled' &&
    (status === 'waiting_for_charge' || status === 'charged' || status === 'finished')
  ) {
    return (
      <ReceptionStatus
        label="配達待ち"
        chipColor="grey"
        labelColor="white"
        detailedStatus={{ label: '返送中', color: 'pink', iconName: 'uber' }}
      />
    );
  }

  if (
    uberDeliveryStatus === 'pickup' &&
    (status === 'waiting_for_charge' || status === 'charged')
  ) {
    return (
      <ReceptionStatus
        label="集荷待ち"
        chipColor="cyan"
        labelColor="white"
        detailedStatus={{ label: '配達員待ち', color: 'black', iconName: 'uber' }}
      />
    );
  }

  if (uberDeliveryStatus === 'pending' && status === 'waiting_for_charge') {
    return <ReceptionStatus label="集荷待ち" chipColor="cyan" labelColor="white" />;
  }

  return null;
};
